<template>
  <div class="statistiques">
    <h4>Statistiques</h4>
    <table>
      <tr><td><router-link to="/clients">clients</router-link></td><td>{{ clientsCount }}</td></tr>
      <tr><td><router-link to="/historique">commandes</router-link></td><td>{{ commandesCount }}</td></tr>
    </table>
  </div>
</template>

<script>
export default {
    name: 'Stats',
    components: { },
    mounted () {
        this.$db.commandes.allDocs().then(r => this.commandesCount = r.rows.length);
        this.$db.customers.allDocs().then(r => this.clientsCount = r.rows.length);
    },
    data () { return { clientsCount: 0, commandesCount: 0 } }
}
</script>

<style>
  .statistiques {
  padding: 1em;
  margin: 1em;
  }
  .statistiques td {
  padding: 0 4px;
  }
</style>
